import { AuditLogRepository } from './ports/AuditLogRepository';
import { CreateSecurityLogUseCase } from './usecases/CreateSecurityLogUseCase';
import { CreateStaffActivityLogUseCase } from './usecases/CreateStaffActivityLogUseCase';
import { GetStaffActivityLogsUseCase } from './usecases/GetStaffActivityLogsUseCase';
import { SupabaseAuditLogRepository } from '@infrastructure/supabase/SupabaseAuditLogRepository';

class AuditDomainFactory {
  private repository: AuditLogRepository;

  constructor() {
    this.repository = new SupabaseAuditLogRepository();
  }

  getCreateSecurityLogUseCase() {
    return new CreateSecurityLogUseCase(this.repository);
  }

  getCreateStaffActivityLogUseCase() {
    return new CreateStaffActivityLogUseCase(this.repository);
  }

  getGetStaffActivityLogsUseCase() {
    return new GetStaffActivityLogsUseCase(this.repository);
  }

  getRepository() {
    return this.repository;
  }
}

export const auditDomain = new AuditDomainFactory();
